import type { ConvertableUnit } from "@/libs/units";
import { buildOptions } from "./buildOptions";

export const FeetPerSecond: ConvertableUnit = {
  label: "ft/s",
  toStandardUnit: u => u,
  toThisUnit: u => u
};

export const MetersPerSecond: ConvertableUnit = {
  label: "m/s",
  toStandardUnit: m => m * 3.280839895,
  toThisUnit: ft => ft / 3.280839895
};

const unitList = [FeetPerSecond, MetersPerSecond];
export const SpeedUnits = {
  FeetPerSecond,
  MetersPerSecond,
  options: buildOptions(unitList)
};
